import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useUpdatePaymentSummary() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.updatePaymentSummaryDocumentsDocumentKeyEobSummaryPutMutation(),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        apiClient.getPaymentSummaryDocumentsDocumentKeyEobSummaryGetOptions({
          path: { document_key: variables.path.document_key },
        }),
      )
      queryClient.invalidateQueries(
        apiClient.getDocumentDocumentsKeyGetOptions({
          path: { key: variables.path.document_key },
        }),
      )
      queryClient.invalidateQueries(
        apiClient.getDocumentAuditTrailDocumentsKeyAuditTrailGetOptions({
          path: { key: variables.path.document_key },
        }),
      )
    },
  })
}
